module.exports = __webpack_public_path__ + "static/media/evolution_75.5258b3d2.svg";